/*eslint-disable no-template-curly-in-string */
import { DloInput } from "@7egend/web-core"

export class LocationsGetByUserIdInput extends DloInput<{
	uuid: number | string
}> {
	public uri = "users/${uuid}/places?fields=${fields}"
	public fields = "uuid,name"
}
